import fetch from '../../../services/fetch'

const getMajorByOrgId = (orgId) => {
    return fetch.get('org/get/major/' + orgId)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const getTemplateById = (id) => {
    return fetch.get('template/getTemplateById/' +id)
}

const deleteFile = (dataList)=> {
    const ids = dataList.map(d => d.id);
    return fetch.post('graduation/entring/file/delete', ids);
}

const save = (data) => {
    return fetch.post('graduation/entring/save', data);
}

const saveCourse = (data) => {
    return fetch.post('graduation/course/save', data);
}

const studentSave = (data) => {
    return fetch.post('graduation/entring/studentSave', data);
}

const getOwnContentById = (id) => {
    return fetch.get('graduation/result/get/own/content/' +id)
}

const geCourseContentById = (id) => {
    return fetch.get('graduation/course/get/content/' +id)
}

export default{
    upload : `${fetch.base}graduation/entring/file`,
    getMajorByOrgId , 
    getTemplateById ,
    deleteFile ,
    save,
    saveCourse,
    studentSave,
    getOwnContentById,
    geCourseContentById
}